"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _api = require("../../../../../api");

var _RemoveMembershipModal = _interopRequireDefault(require("../components/RemoveMembershipModal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function RemoveMembershipModal(_ref) {
  var visible = _ref.visible,
      onClose = _ref.onClose,
      membership = _ref.membership,
      onMembershipDeleted = _ref.onMembershipDeleted,
      teamName = _ref.teamName;
  return _react.default.createElement(_commonReact.AuthorisationConsumer, {
    requiresOrganisation: true
  }, function () {
    return _react.default.createElement(_commonReact.RequestProvider, {
      requests: {
        deleteTeamMembershipApi: (0, _api.deleteTeamMembership)()
      }
    }, function (_ref2) {
      var deleteTeamMembershipApi = _ref2.deleteTeamMembershipApi;
      return _react.default.createElement(_RemoveMembershipModal.default, {
        visible: visible,
        onClose: onClose,
        teamName: teamName,
        deleteTeamMembershipApi: deleteTeamMembershipApi,
        onMembershipDeleted: onMembershipDeleted,
        membership: membership
      });
    });
  });
}

var _default = (0, _react.memo)(RemoveMembershipModal);

exports.default = _default;